import * as React from 'react';
import { FullscreenCard } from 'Components/FullscreenCard';

interface Props {
	title?: string;
	children?: React.ReactNode;
}

export function LoginMessage(props: Props) {
	return (
		<FullscreenCard centerContent className="web-screen">
			{props.title && <h1 className="authentication-title main-text">{props.title}</h1>}
			{props.children}
		</FullscreenCard>
	);
}
